import { h } from 'preact';

export const BadgeCheckIcon = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
    {...props}
  >
    <path d="M12 2C14.6522 2 17.1959 3.05335 19.0713 4.92871C20.9467 6.80408 22 9.34784 22 12C22 14.6522 20.9467 17.1959 19.0713 19.0713C17.1959 20.9467 14.6522 22 12 22C9.34784 22 6.80408 20.9467 4.92871 19.0713C3.05335 17.1959 2 14.6522 2 12L2.0127 11.5039C2.13537 9.03237 3.17061 6.68681 4.92871 4.92871C6.80407 3.05335 9.34783 2 12 2Z" fill="#7E8FFF" stroke="white" strokeWidth="2"/>
    <path d="M7.91679 12.5833L10.2501 14.9167L16.0835 9.08333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
